import React, { useState } from 'react';
import { Tooltip, Popover, Button } from 'antd';
import styles from './COPopover.module.scss';
import {
  BadgePlacements,
  ButtonLabels,
  PopoverProps,
  TriggerEnums,
} from 'enums/COPopoverEnums';
import COButton from '../COButton';
export interface COPopoverProps {
  children?: React.ReactNode;
  placement?:
    | BadgePlacements.TOP
    | BadgePlacements.LEFT
    | BadgePlacements.RIGHT
    | BadgePlacements.BOTTOM
    | BadgePlacements.TR;
  text?: string | HTMLElement;
  title?: string | HTMLElement;
  trigger?: TriggerEnums.CLICK | TriggerEnums.HOVER;
  actionable?: boolean;
}
const COPopover = ({
  actionable,
  children,
  placement,
  text,
  title,
  trigger,
}: COPopoverProps) => {
  const [open, setOpen] = React.useState(false);
  const hideBig = () => {
    setOpen(false);
  };

  const [clicked, setClicked] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handleClickChange = (open: boolean) => {
    setHovered(false);
    setClicked(open);
  };

  const clickContent = <p>{PopoverProps.CLICK_CONTENT}</p>;
  return (
    <>
      {actionable ? (
        <Popover
          content={
            <div className={styles.popoverContent}>
              {clickContent}
              <div className={styles.buttonrow}>
                <COButton text onClick={hideBig}>
                  {ButtonLabels.SKIP}
                </COButton>
                <div className={styles.buttonContainer}>
                  <Button className={styles.secondaryBtn} onClick={hideBig}>
                    {ButtonLabels.PREVIOUS}
                  </Button>
                  <COButton onClick={hideBig}>{ButtonLabels.NEXT}</COButton>
                </div>
              </div>
            </div>
          }
          title={TriggerEnums.TITLE}
          trigger={TriggerEnums.CLICK}
          visible={clicked}
          color={TriggerEnums.POPOVER_BG}
          onVisibleChange={handleClickChange}>
          {children}
        </Popover>
      ) : (
        <Tooltip
          color={TriggerEnums.POPOVER_BG}
          placement={placement}
          title={text}
          className={styles.tooltipcontainer}>
          <div>{children}</div>
        </Tooltip>
      )}
    </>
  );
};

export default COPopover;
